import dataStore from "./store";

import { getImageSrc } from './../tool/image-functions'

const globalFunctions = {

    addImageFile: function(type) {

        if (type == 'organisation') {

            document.getElementById('logo').click()

        } else if (type == 'popup') {

            document.getElementById('popupfile').click()

        } else if ('logo-instead') {

            document.getElementById('logo-instead').click()
        }

    },

    toggleAddMedia: function( questionType = null, editMode = null, itemType = null ) {

        dataStore.showMediaPopup = ! dataStore.showMediaPopup

        dataStore.questionType = questionType

        dataStore.editMode = editMode ? true : false

        dataStore.errorsAdmin = []

        if (editMode == null) {

            resetOtherValues();

            if (itemType) {
                dataStore.activeType = itemType
            }
        }

        if ( ( questionType === 'freetext' || questionType === 'scale' ) && editMode === null ) {
            dataStore.activeType = 'question'
        }

        if ( dataStore.activeType === 'map' && editMode == null ) {
            defaultMapValues()
        }

    },

    toggleFindPlace: function() {
        dataStore.showFindPlace = !dataStore.showFindPlace;
    },

    addDefaultPathsIfEmpty: function(items) {

        items.map(item => {

            if ( item.item_paths.length === 0 ) {

                item.item_paths = [

                    { lat: 57.49012, lng: 18.47251 },
                    { lat: 57.4887, lng: 18.46966 },
                    { lat: 57.4060961, lng: 18.400642 },
                    { lat: 57.3948914, lng: 18.7414466 }

                ]

            }

            return item;
        });

        return items;
    },

    getPaths: function(paths) {

        let itemPaths = [];

        if (paths) {

            if (paths.length) {

                itemPaths = paths.map(val => {
                    return [ parseFloat(val.lng), parseFloat(val.lat) ]
                });

            }

            return [itemPaths]
        }
    },

    // check if there is any items with answers - then not allow to change on items
    checkIfAllowToEdit: function(items, isPublic) {
        items.map(item => {
            if (item.answers.length > 0 && isPublic) {
                dataStore.project.allowToEdit = false;
            }
        });
    },

    getLogoUrl: function(image) {
        if (typeof image === "string" && image.includes("data:image/")) {
            return image;
        } else {
            return `/images/projects/project-logo/${image}`;
        }
    },

    getLogoUrlInsteadName: function(image) {
        if (typeof image === "string" && image.includes("data:image/")) {
            return image;
        } else {
            return `/images/projects/project-logo/${image}`;
        }
    },

    getMediaImageUrl: function(image) {
        if (typeof image === "string" && image.includes("data:image/")) {
            return image;
        } else {
            return `/images/projects/${getImageSrc(image, 'scaled')}`;
        }
    }

};

const resetOtherValues = function() {

    dataStore.editMode = false;
    dataStore.activeVideoUrl = "";
    dataStore.typeOfVideo = 0;
    dataStore.active3dIframe = "";
    dataStore.activeQuestion = "";
    dataStore.activeIndex = null;
    dataStore.popUpMediaFile = false;
    dataStore.showInfoBoxEditor = false;
    dataStore.allowUploadImage = true;
    dataStore.allowLimitMarkers = false;
    dataStore.allowMultiAnswersScale = false;
    dataStore.amountAnswers = 5;
    dataStore.mapSearch = false
    dataStore.responseFormDescription = ''

    // default to true = checked
    dataStore.allowGoodOptions = true;
    dataStore.allowBadOptions = true;

    dataStore.project.scaleOptions = [];

    dataStore.activeScaleType = 'DEFAULT';

    if (dataStore.questionType === "goodbad") {
        dataStore.activeType = "map";
    }

    if (dataStore.questionType === "scale") {
        dataStore.activeType = "image";
    }

    if (dataStore.questionType === "freetext") {
        dataStore.activeType = "image";
    }

}

const defaultMapValues = function () {

    //default restrictions when creating new map comment out later or make a function to create

    dataStore.activeMapObj = {
        centerLat: 61.6706531,
        centerLng: 18.687777,
        paths: [],
        activeType: dataStore.activeType,
        questionType: dataStore.questionType
    };

    dataStore.center = "";

    dataStore.disableMapEditor = true;

}

export default globalFunctions;
